import { render, staticRenderFns } from "./CompanySettingsPage.vue?vue&type=template&id=21b0e858&scoped=true&lang=pug&"
import script from "./CompanySettingsPage.vue?vue&type=script&lang=ts&"
export * from "./CompanySettingsPage.vue?vue&type=script&lang=ts&"
import style0 from "./CompanySettingsPage.vue?vue&type=style&index=0&id=21b0e858&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b0e858",
  null
  
)

export default component.exports